module.exports = __webpack_public_path__ + "img/google-drawing.png";